import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `referral` namespace — the referral dashboard: invite link, credit
 * rewards, and spend-back tracking.
 */
export const referral = {
  title: 'Invite friends',
  link: {
    label: 'Your referral link',
    copy: 'Copy link',
    copied: 'Copied!',
  },
  rewards: {
    signupBonus: 'Get {credits} credits for every {batchSize} friends who sign up.',
    spendBack: 'Earn {percent}% of your referrals’ spend back as credits.',
  },
  stats: {
    invited: '{count} invited',
    joined: '{count} joined',
    earned: '{amount} credits earned',
  },
  status: {
    pending: 'Pending',
    qualified: 'Joined',
    revoked: 'Not eligible',
  },
  empty: 'No referrals yet. Share your link to start earning.',
} as const;

export type ReferralMessages = typeof referral;

/** Typo-safe dot-path keys for the `referral` namespace. */
export type ReferralKey = NestedKeys<ReferralMessages>;
